module.exports = "<a href=\"{{Model.Value.Url}}\" class=\"history-item-link\" data-type=\"link\" data-id=\"{{Model.Value.SiteId}}\" target=\"_blank\">\r\n    <i aria-hidden=\"true\" class=\"fa fa-external-link-sign\"></i>\r\n    {{Model.Value.Name}}\r\n</a>\r\n<div class=\"timestamp\" title=\"{{Model.Timestamp}}\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/user-history/views/user-history-item-full-text.html
// module id = 451
// module chunks = 1